import { useMemo } from "react"

import { useFindIngestions } from "~/gen/api"

export type FiltersOptions = {
  userEmails: string[]
  createdAtOptions: Date[]
  fileNameOptions: string[]
}

export const useFiltersOptions = () => {
  const { data: ingestionList } = useFindIngestions({
    sorts: {},
    filters: {},
  })

  const filtersOptions = useMemo(() => {
    const result: {
      userEmails: Set<string>
      createdAtOptions: Set<Date>
      fileNameOptions: Set<string>
    } = {
      userEmails: new Set<string>(),
      createdAtOptions: new Set<Date>(),
      fileNameOptions: new Set<string>(),
    }

    if (!ingestionList) return result

    return ingestionList.data.reduce((acc, ingestion) => {
      if (ingestion.createdBy?.email) {
        acc.userEmails.add(ingestion.createdBy.email)
      }
      if (ingestion.createdAt) {
        acc.createdAtOptions.add(ingestion.createdAt)
      }
      if (ingestion.document?.originalFileName) {
        acc.fileNameOptions.add(ingestion.document.originalFileName)
      }
      return acc
    }, result)
  }, [ingestionList])

  return {
    userEmails: Array.from(filtersOptions.userEmails),
    createdAtOptions: Array.from(filtersOptions.createdAtOptions),
    fileNameOptions: Array.from(filtersOptions.fileNameOptions),
  }
}
